/**
 * Event Types Configuration for Service Requests
 * 
 * This is the authoritative list of event types used across the application.
 * All event type dropdowns, filters, and reports should reference this list.
 * 
 * IMPORTANT: The list is sorted alphabetically (A-Z) for consistent UI presentation.
 */

// Full list of event types - alphabetically sorted
export const EVENT_TYPES = [
  'Brake Testing',
  'Coating/Lining',
  'Derailment',
  'Exterior Cleaning',
  // 2026-07-06 — Flaring added
  'Flaring',
  'General Inspection/Repair',
  'Heavy Repair',
  'Interior Cleaning',
  'Interior Inspection',
  // 2026-07-18 — JIC added
  'JIC',
  'Markings',
  'Mechanical',
  'NDT',
  'OTMA',
  // 2026-07-18 — Other added
  'Other',
  'Paint',
  // 2026-07-06 — 'Home Shop' renamed to 'Prep For Home Shop' (see EVENT_TYPE_ALIASES)
  'Prep For Home Shop',
  'Qualification',
  'Running Gear',
  'Scrap Car',
  'Service Equipment',
  // 2026-07-06 — Transload added
  'Transload',
  'Welding',
  'Wheels',
].sort((a, b) => a.localeCompare(b));

// 2026-07-06 — Historical rows saved with the old 'Home Shop' label should still
// resolve to the new 'Prep For Home Shop' when displayed. Read paths that want
// backward-compat display can call resolveEventType(); write paths already emit
// the new label. No DB migration required.
export const EVENT_TYPE_ALIASES = {
  'Home Shop': 'Prep For Home Shop',
};

export const resolveEventType = (raw) =>
  raw ? (EVENT_TYPE_ALIASES[raw] || raw) : raw;

// For filter dropdowns - includes value/label format
export const EVENT_TYPE_OPTIONS = EVENT_TYPES.map(type => ({
  value: type,
  label: type
}));

// Helper to validate if a given type is valid
export const isValidEventType = (type) => EVENT_TYPES.includes(type);

// Export count for reporting
export const EVENT_TYPES_COUNT = EVENT_TYPES.length;
